import * as stylex from "@stylexjs/stylex";
import { colors, fonts, radii } from "@softmax/design-system/tokens.stylex";

export const replayStyles = stylex.create({
  visuallyHidden: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
  frame: {
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  bordered: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: `var(--border, ${colors.border})`,
    borderRadius: 4,
  },
  surface: { backgroundColor: `var(--surface-alt, ${colors.surfaceAlt})` },
  page: { backgroundColor: `var(--bg, ${colors.background})` },
  viewer: { backgroundColor: "#000" },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    padding: 16,
    textAlign: "center",
  },
  poster: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  gate: {
    position: "relative",
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
  },
  posterGate: {
    borderRadius: 4,
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    paddingInline: 16,
    paddingBlock: 12,
  },
  text: { color: `var(--fg-muted, ${colors.muted})`, fontSize: 14 },
  smallText: { color: `var(--fg-muted, ${colors.muted})`, fontSize: 12 },
  posterText: { color: "#fff" },
  action: {
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: `var(--border, ${colors.border})`,
    paddingInline: 12,
    paddingBlock: 4,
    color: `var(--fg, ${colors.foreground})`,
    backgroundColor: {
      default: "transparent",
      ":hover": `var(--surface, ${colors.surface})`,
    },
    fontFamily: fonts.sans,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    outline: {
      default: "none",
      ":focus-visible": `2px solid var(--fg, ${colors.foreground})`,
    },
    outlineOffset: 2,
  },
  posterAction: {
    borderColor: "rgba(255, 255, 255, 0.4)",
    color: "#fff",
    backgroundColor: {
      default: "transparent",
      ":hover": "rgba(255, 255, 255, 0.1)",
    },
    outlineColor: "#fff",
  },
  spinner: {
    display: "inline-block",
    width: 16,
    height: 16,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: `var(--border-strong, ${colors.borderStrong})`,
    borderTopColor: `var(--fg, ${colors.foreground})`,
    borderRadius: radii.pill,
    animationName: stylex.keyframes({ to: { transform: "rotate(360deg)" } }),
    animationDuration: "800ms",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
    animationPlayState: {
      default: "running",
      "@media (prefers-reduced-motion: reduce)": "paused",
    },
  },
  progress: { display: "flex", alignItems: "center", gap: 8 },
  iframe: { width: "100%", height: "100%" },
  iframeElement: { borderWidth: 0 },
  overlay: {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  scaledViewer: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
